import { useQuery } from '@tanstack/react-query';
import { Link, useParams, useSearchParams } from 'react-router';
import { AuthShell } from '@/components/AuthShell';
import { SSOButtons } from '@/components/SSOButtons';
import { Banner, Spinner } from '@/components/ui';
import { ApiError, api } from '@/lib/api';
import { safeReturn, ssoErrorMessage } from '@/lib/signIn';

// TenantLoginPage - one organization's sign-in link, /t/:orgId/login: its own
// single sign-on whether or not the general page offers it, and a way to a
// password sign-in. A failed single sign-on through the org comes back here.
export default function TenantLoginPage() {
  const { orgId = '' } = useParams();
  const [params] = useSearchParams();
  const returnPath = safeReturn(params.get('return'));
  const error = params.get('error');

  const orgQ = useQuery({ queryKey: ['sso-org', orgId], queryFn: () => api.ssoOrg(orgId), retry: false });
  const missing = orgQ.error instanceof ApiError && orgQ.error.kind === 'not_found';

  return (
    <AuthShell subtitle="Precision malware analysis">
      <div className="card p-8">
        <div className="mb-6 text-center">
          <h1 className="text-title font-semibold">Sign in</h1>
        </div>

        <div className="flex flex-col gap-5">
          {error && <Banner variant="danger">{ssoErrorMessage(error)}</Banner>}
          {orgQ.isPending && (
            <div className="flex justify-center py-2">
              <Spinner size={20} />
            </div>
          )}
          {missing && <Banner variant="warn">This sign-in link is not set up. Ask your administrator.</Banner>}
          {orgQ.isError && !missing && <Banner variant="danger">Sign-in options did not load. Try again.</Banner>}
          {orgQ.data && <SSOButtons offered={[orgQ.data]} returnPath={returnPath} />}
          <Link to={`/login/local?return=${encodeURIComponent(returnPath)}`} className="btn-ghost w-full justify-center">
            Sign in with a password
          </Link>
        </div>
      </div>
    </AuthShell>
  );
}
